import script from "./Progress_circle.vue?vue&type=script&setup=true&lang=js"
export * from "./Progress_circle.vue?vue&type=script&setup=true&lang=js"

import "./Progress_circle.vue?vue&type=style&index=0&id=05d4b4b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d4b4b0"]])

export default __exports__